import styled from 'styled-components';
import mediainjector from '../../style/mediainjector';


export const SubMenu = styled.section`
  position: relative;
  padding-top: 97px;
  text-align: center;
  background-color: #fff;
  ${mediainjector.lt667`
    padding-top: 72px;
  `}
  nav {
    color: white;
    padding: 2.6rem 0;
    background-color: ${(props) => props.theme.brand};
    span {
      color: white;
      cursor: pointer;
      padding: 0.3rem 1.8rem;
      border-radius: 6px;
      &.current {
        color: ${(props) => props.theme.brand};
        background-color: white;
      }
    }
  }
  z-index: 2
`;
